import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import Tab from '@mui/material/Tab';
import { useLocation, useHistory } from "react-router-dom";
import Container from '@mui/material/Container';
import TopBar from '../components/TopBar';
import { useTranslation } from 'react-i18next';
import NotAuthorized from '../pages/NotAuthorized';
import useAuthorizationStatus from '../hooks/useAuthorizationStatus';
import useSessionData from '../hooks/useSessionData';
import CheckUserRight from '../utils/auth';

interface LayoutProps {
  children?: React.ReactNode;
}

export default function Layout(props: LayoutProps) {
  const location = useLocation();
  var authorizeFor = "";

  if(location.pathname.startsWith("/auditLogReports")){
    authorizeFor = "auditLog";
  } else {
    authorizeFor = "visionAware";
  }

  const isAuthorized = useAuthorizationStatus(location.pathname, authorizeFor);
  const [activeTab, setActiveTab] = useState(0);
  const { t } = useTranslation();
  const session = useSessionData();
  const history = useHistory();
  const menuLabels = [
    t('app_top_menu_1'),
    t('app_top_menu_2'),
    t('app_top_menu_3'),
    t('app_top_menu_4')
  ]

  const handleClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, activeTabIndex: number, href: string) => {
    event.preventDefault();
    setActiveTab(activeTabIndex);
    history.push(href);
  }
  const canShowAuditReports = () => {
    if(!session) return false;

    const userRight = CheckUserRight(session?.info?.rights, 'auditLog');
    return userRight.read;
  };

  const canShowROIReports = () => {
    if(!session) return false;
    const userRight = CheckUserRight(session?.info?.rights, 'visionAware');
    return userRight.read;
  };
  
  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith('/traffic')) {
      setActiveTab(3);
    } else if (path.startsWith('/auditLogReports')) {
      setActiveTab(1);
    } else if (path.startsWith('/events')) {
      setActiveTab(2);
    } else if (path.startsWith('/roi')) {
      setActiveTab(0);
    }
  }, [location.pathname]);


  return (
    <Box sx={{
      display: 'flex',
      background: 'linear-gradient(180deg, #F5F7FA, #F7F9FB, #FFFFFF);'
    }}>
      <CssBaseline />
      <TopBar activeTab={activeTab}>
        {canShowROIReports() && <Tab label={menuLabels[0]} value={0} onClick={(e) => handleClick(e, 0, '/roi')} />}
        {canShowAuditReports() && <Tab label={menuLabels[1]} value={1} onClick={(e) => handleClick(e, 1, '/auditLogReports')} />}
      </TopBar>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          height: '100vh',
          overflow: 'auto',
          pr: {
            xs: 1,
            lg: 4,
            xl: 4,
          },
          pl: {
            xs: 1,
            lg: 4,
            xl: 24,
          },
        }}
      >
        <Toolbar />

        <Container maxWidth={false}
          sx={{
            mt: 4, mb: 4, pt: 3, pb: 4,
          }}>

          {isAuthorized && props.children}

          {!isAuthorized && <NotAuthorized />}

        </Container>


      </Box>

    </Box>
  )


}
